import { MySkillsGrid } from "@/components/skills/MySkillsGrid";

export function MySkillsPage() {
  return <MySkillsGrid />;
}
